import {
  OpenCall,
  OpenCallQuery,
  OpenCallsQuery,
} from '@repo/api/open-calls/graphql';
import { OpenCallModel } from '@repo/ui/models/index';
import dayjs from 'dayjs';
import request from 'graphql-request';

import { ConfigService } from '@/services';
import { QueryStateManagement } from '@/state';
import * as constants from '../constants';
import { openCallQuery, openCallsQuery } from './queries.graphql';

export type OpenCallsPage = {
  items: OpenCallModel[];
  totalCount: number;
  page: number;
  limit: number;
};

export class OpenCallService {
  static async all(page: number, limit: number): Promise<OpenCallsPage> {
    const response = await QueryStateManagement.client.fetchQuery({
      queryKey: ['open-calls', page, limit],
      queryFn: () =>
        request<OpenCallsQuery>(
          ConfigService.BACKEND_GRAPHQL_ENDPOINT,
          openCallsQuery,
          { page, limit },
          OpenCallService.headers,
        ),
      gcTime: constants.QUERY_CACHE_TIME,
    });

    return {
      ...response.openCalls,
      items: response.openCalls.items.map((openCall) =>
        OpenCallService.toModel(openCall as OpenCall),
      ),
    };
  }

  static async byId(id: string): Promise<OpenCallModel | undefined> {
    const response = await QueryStateManagement.client.fetchQuery({
      queryKey: ['open-call', id],
      queryFn: () =>
        request<OpenCallQuery>(
          ConfigService.BACKEND_GRAPHQL_ENDPOINT,
          openCallQuery,
          { id },
          OpenCallService.headers,
        ),
      gcTime: constants.QUERY_CACHE_TIME,
    });

    return response.openCall
      ? OpenCallService.toModel(response.openCall as OpenCall)
      : undefined;
  }

  private static get headers() {
    return {
      Authorization: `Bearer ${sessionStorage.getItem(constants.TOKEN_STORAGE_KEY)}`,
    };
  }

  private static toModel(openCall: OpenCall): OpenCallModel {
    return new OpenCallModel({
      id: openCall.id,
      name: openCall.name,
      isAmericanStyleOpenCall: openCall.isAmericanStyleOpenCall ?? false,
      typeId: openCall.typeId,
      status: openCall.status,
      totalApplicants: openCall.totalApplicants,
      createdAt: dayjs(openCall.createdAt).format('MMMM D, YYYY'),
      closedAt: dayjs(openCall.closedAt).format('MMMM D, YYYY'),
      brand: openCall.brand,
      stages: openCall.stages,
      defaultStageId: openCall.defaultStageId,
    });
  }
}
